import { generatePath, matchPath } from "react-router-dom";

export default class Link {
  constructor(merchantId, name, icon, path, component, authenticationName) {
    this.merchantId = merchantId;
    this.name = name;
    this.icon = icon;
    this.path = path;
    this.component = component;
    this.authenticationName = authenticationName;
  }

  getLink() {
    return generatePath(this.path, { merchantId: this.merchantId });
  }

  match(pathname) {
    return matchPath(pathname, { path: this.getLink() });
  }
}
